import api from "./api";
import type { ConfigOrcamento } from "../types/orcamento";

export interface CampoConfig {
  type:
    | "text"
    | "textarea"
    | "number"
    | "select"
    | "currency"
    | "date"
    | "url"
    | "file"
    | "orcamento";
  label: string;
  required?: boolean;
  placeholder?: string;
  maxLength?: number;
  min?: number;
  max?: number;
  default?: string | number;
  options?: string[];
  accept?: string; // para type='file'
  ordem?: number;
  config?: ConfigOrcamento; // para type='orcamento'
}

export interface Template {
  id: number;
  nome: string;
  descricao: string;
  versao: number;
  ativo: boolean;
  schema_campos: Record<string, CampoConfig>;
  configuracoes_padrao?: Record<string, unknown>;
  total_editais?: number;
  criado_por?: {
    id: number;
    nome: string;
  };
  created_at?: string;
  updated_at?: string;
}

export interface CriarTemplateParams {
  nome: string;
  descricao: string;
  schema_campos: Record<string, CampoConfig>;
  configuracoes_padrao?: Record<string, unknown>;
}

const templatesAdminService = {
  // Listar templates
  listar: async (params?: {
    ativo?: boolean;
  }): Promise<{ templates: Template[] }> => {
    const response = await api.get("/api/v1/admin/edital_templates", {
      params,
    });
    return response.data;
  },

  // Buscar template por ID
  buscar: async (id: number): Promise<{ template: Template }> => {
    const response = await api.get(`/api/v1/admin/edital_templates/${id}`);
    return response.data;
  },

  // Criar template
  criar: async (
    data: CriarTemplateParams
  ): Promise<{ message: string; template: Template }> => {
    const response = await api.post("/api/v1/admin/edital_templates", data);
    return response.data;
  },

  // Atualizar template
  atualizar: async (
    id: number,
    data: Partial<CriarTemplateParams>
  ): Promise<{ message: string; template: Template }> => {
    const response = await api.put(
      `/api/v1/admin/edital_templates/${id}`,
      data
    );
    return response.data;
  },

  // Ativar template
  ativar: async (
    id: number
  ): Promise<{ message: string; template: Template }> => {
    const response = await api.post(
      `/api/v1/admin/edital_templates/${id}/ativar`
    );
    return response.data;
  },

  // Desativar template
  desativar: async (
    id: number
  ): Promise<{ message: string; template: Template }> => {
    const response = await api.post(
      `/api/v1/admin/edital_templates/${id}/desativar`
    );
    return response.data;
  },

  // Duplicar template
  duplicar: async (
    id: number
  ): Promise<{ message: string; template: Template }> => {
    const response = await api.post(
      `/api/v1/admin/edital_templates/${id}/duplicar`
    );
    return response.data;
  },

  // Excluir template
  excluir: async (id: number): Promise<{ message: string }> => {
    const response = await api.delete(`/api/v1/admin/edital_templates/${id}`);
    return response.data;
  },
};

export default templatesAdminService;
